
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { updatePiPurchaseOrderGroup } from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
@Component({
  name: "ModifySplit",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isEdit: boolean;
  @Prop({ default: [] }) private selectedList: [];
  @Prop({ default: "" }) private inquirySheetId: "";
  @Prop({ default: "修改订单拆分" }) private title: "";
  private form = {
    saleDiscount: null,
    purchaseDiscount: null,
  };
  private splitType = 0;
  private newSelectedRows: any[] = [];

  @Watch("selectedList", { immediate: true })
  private async watchData() {
    this.newSelectedRows = deepClone(this.selectedList);
    // console.log(this.newSelectedRows)
  }
  private list = [
    {
      label: "订单拆分",
      prop: "conversionMarginProfit",
      key: "conversionMarginProfit",
      type: "input",
      placeholder: "订单拆分",
      // options: [
      //   {
      //     name: '是',
      //     type: '1'
      //   },
      //   {
      //     name: '否',
      //     type: '2'
      //   },
      // ],
      // labelKey:'name',
      // valueKey:'type',
    },
  ];
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  // private changeUpdate({ data }) {
  //   this.splitType = data.value;
  // }
  private changeUpdate({ data }) {
    this.splitType = data.value;
  }
  private async submitForm(): Promise<void> {
    try {
      this.updateDraftDiscount(this.form);
    } catch (error) {
      console.error(error);
    }
  }
  private async updateDraftDiscount(form: any) {
    if (!this.newSelectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    const proformaInvoiceIds = this.newSelectedRows.map((item) => item.id);
    let params = {
      proformaInvoiceIds,
      purchaseOrderGroup: this.splitType,
    };
    try {
      await updatePiPurchaseOrderGroup(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }
}
